import { useQuery } from '@tanstack/react-query'
import { getSoapEditHistory, SoapEditHistoryItem } from '@/shared/apis/yakureki'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'

/**
 * SOAP編集履歴取得Query
 *
 * 責務:
 * - 指定された薬歴のSOAP編集履歴を取得
 * - yakurekiIdが未指定の場合はクエリを無効化
 */
export const useSoapEditHistoryQuery = (yakurekiId?: string) => {
  return useQuery<SoapEditHistoryItem[]>({
    queryKey: queryKeys.soapEditHistory.list(yakurekiId ?? ''),
    queryFn: async () => {
      const response = await getSoapEditHistory(yakurekiId!)
      return response.data
    },
    enabled: !!yakurekiId,
  })
}
